import Missing from '@assets/svg/match/missing.svg';
import Late from '@assets/svg/match/late.svg';
import Attending from '@assets/svg/match/attending.svg';
import {Wrapper} from './AttendanceIcon.styled';
import {AttendanceStatus} from '@models/AttendanceType';
import {useTheme} from '@emotion/react';


interface IProps{
    attendanceStatus:any,
    isContrast: boolean,
    midPos?: boolean
}
  
export const AttendanceIcon = (props: IProps) => {


    const theme = useTheme(); 
    let returnIcon;
    let backgroundColor;

    if(props.attendanceStatus !== AttendanceStatus.Unknown){
        switch (props.attendanceStatus) {
            case AttendanceStatus.Attending:
                returnIcon = <Attending /> ;
                backgroundColor = theme.colors.placeholderColor;
                break;
            case AttendanceStatus.Missing:
                returnIcon = <Missing /> ;
                backgroundColor = theme.colors.red;
                break;
            case AttendanceStatus.Late:
                returnIcon = <Late /> ;
                backgroundColor = theme.colors.yellow;
                break;
            
        }
    }

    return <>
        {props.attendanceStatus === AttendanceStatus.Unknown?
        ""
        :
        <Wrapper midPos={props.midPos} iconBack={props.isContrast?theme.colors.white:backgroundColor} contrast={props.isContrast} >
            {returnIcon}
        </Wrapper>
        }
    </>;
};

export default AttendanceIcon;